import { render, staticRenderFns } from "./CloudCard.vue?vue&type=template&id=486e40cc&scoped=true&"
import script from "./CloudCard.vue?vue&type=script&lang=js&"
export * from "./CloudCard.vue?vue&type=script&lang=js&"
import style0 from "./CloudCard.vue?vue&type=style&index=0&id=486e40cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486e40cc",
  null
  
)

export default component.exports